import type { QueryClient } from '@tanstack/react-query';
import { queryKeys } from 'core/query/queryKeys';

type FleetInvalidationOptions = {
  orgId?: string | null;
  vehicleId?: string;
};

/** Refetch fleet, driver roster, and related provider queries. */
export async function invalidateFleetQueries(
  queryClient: QueryClient,
  options: FleetInvalidationOptions = {},
): Promise<void> {
  const tasks: Promise<unknown>[] = [
    queryClient.invalidateQueries({ queryKey: queryKeys.vehicles.mine }),
    queryClient.invalidateQueries({ queryKey: queryKeys.drivers.me }),
  ];

  if (options.orgId) {
    tasks.push(
      queryClient.invalidateQueries({
        queryKey: queryKeys.organizations.assignable(options.orgId),
      }),
      queryClient.invalidateQueries({
        queryKey: queryKeys.organizations.drivers(options.orgId),
      }),
      queryClient.invalidateQueries({
        queryKey: queryKeys.organizations.members(options.orgId),
      }),
      queryClient.invalidateQueries({
        queryKey: queryKeys.drivers.licenceStatus(options.orgId),
      }),
    );
  } else {
    tasks.push(
      queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey[0] === 'organizations' &&
          query.queryKey[2] === 'assignable',
      }),
    );
  }

  if (options.vehicleId) {
    tasks.push(
      queryClient.invalidateQueries({
        queryKey: queryKeys.vehicles.detail(options.vehicleId),
      }),
    );
  }

  await Promise.all(tasks);
}
